import {internalApi} from "../../../common/axios";
import {useMutationBase, useQueryBase} from "../../../shared/hooks/useHookBase";
import {PersonalPackageGroupEntity} from "./PersonalPackageGroupEntity";

const fetchPersonalPackage = async () => {
    const {data} = await internalApi.get('store_manager/personalPackage');
    return data.rows;
};

export const usePersonalPackage = () => useQueryBase(['personalPackage'], fetchPersonalPackage);

const savePersonalPackage = async (packageData) => {
    const {data} = await internalApi.post('store_manager/personalPackage', {data: packageData});
    return data;
};

export const useSavePersonalPackage = () => useMutationBase('personalPackage', savePersonalPackage);

const deletePersonalPackage = async (seq) => {
    await internalApi.delete('store_manager/personalPackage', {params: {seq}});
};

export const useDeletePersonalPackage = () => useMutationBase('personalPackage', deletePersonalPackage);

const fetchPersonalPackageGroupAll = async () => {
    const {data} = await internalApi.get('store_manager/personalPackageGroup');
    return (data.rows || []).map(r => new PersonalPackageGroupEntity(r));
};

export const usePersonalPackageGroupAll = () => useQueryBase(['personalPackageGroup'], fetchPersonalPackageGroupAll);

const fetchPersonalTableData = async () => {
    const {data} = await internalApi.get('store_manager/personalTable');
    return data.rows;
};

export const usePersonalTableData = () => useQueryBase(['personalTableData'], fetchPersonalTableData);
